import { useDeleteHandler } from '@vlabs/api/artemy/client';
import type { HandlerId } from '@vlabs/api/artemy/model';
import { openConfirmPopup } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

interface UseDeleteHandlerWithConfirmationProps {
  handlerId?: HandlerId;
}

type UseDeleteHandlerWithConfirmationReturn = VoidFunction | undefined;

function useDeleteHandlerWithConfirmation({
  handlerId = undefined,
}: UseDeleteHandlerWithConfirmationProps): UseDeleteHandlerWithConfirmationReturn {
  const { t } = useTranslation();
  const deleteHandler = useDeleteHandler();

  if (!handlerId) return undefined;

  return () => {
    openConfirmPopup({
      title: t('handlers:удаление сценария'),
      message: t('handlers:подтверждение.удаление.текст', {
        handler: handlerId,
      }),
      type: 'delete',
      onConfirm: async () => deleteHandler.mutateAsync({ handlerId }),
    });
  };
}

export { useDeleteHandlerWithConfirmation };
